import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { type ListMediaPackagesParams, listMediaPackages } from '~/services/MediaService';

import { mediaPackageQueryKeys } from './mediaQueryKeys';

/** Fetches a page of media packages, keeping the current rows on screen while the next load. */
export function useGetMediaPackages(params: ListMediaPackagesParams) {
  return useQuery({
    queryKey: mediaPackageQueryKeys.list(params),
    queryFn: ({ signal }) => listMediaPackages(params, { signal }),
    placeholderData: keepPreviousData,
  });
}
